"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SaveClassConfigurationAsDialogModule = /** @class */ (function () {
    function SaveClassConfigurationAsDialogModule() {
    }
    return SaveClassConfigurationAsDialogModule;
}());
exports.SaveClassConfigurationAsDialogModule = SaveClassConfigurationAsDialogModule;
